import { BlocksTableObject } from 'blocks-nextjs/blocks-web-components/components/table-object/table-object';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';
export const CatTableObject = createComponent({
    react: React,
    tagName: 'cat-table-object',
    elementClass: BlocksTableObject,
    events: {
        onBlTableScrollY: 'bl-table-scroll-y',
        onBlTableScrollYEnd: 'bl-table-scroll-y-end',
        onBlTableScrollX: 'bl-table-scroll-x',
        onBlTableScrollXEnd: 'bl-table-scroll-x-end',
        onBlRowExpand: 'bl-row-expand',
        onBlTableResize: 'bl-table-resize',
        onBlRowDragEnd: 'bl-row-drag-end',
        onBlRowCellSelectAll: 'bl-row-cell-select-all'
    }
});
